import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProgressBar from '../Components/ProgressBar';
import NavigationButtons from '../Components/NavigationButtons';
import Navbar from '../Components/Navbar';
import SurveyQuestion from '../Components/SurveyQuestion';  // Import the new component
import { Box, Text } from '@chakra-ui/react';

const SurveyPage2 = ({ surveyData, setSurveyData }) => {
  const [formData, setFormData] = useState(surveyData || {});
  const navigate = useNavigate();
  const handleNext = () => {
    if (formData) {
      setSurveyData(formData)
      navigate('/surveypage3'); // Navigate to the next step
    }
  };

  const handleBack = () => {
    setSurveyData(formData)
    navigate('/survey'); // Change this to the previous step
  };

  return (
    <Box>
      {/* Top Bar */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Survey Content */}
      <Box padding="20px" maxWidth="1200px" margin="auto">
        <Text fontSize="20px" fontWeight="bold" mt="20px">Freelance Preference Survey</Text>
        <Text color="#6E6E6E" mb="12px" fontStyle="italic">
          Please fill this survey out so that we have a better understanding of how to assist you! :)
        </Text>

        {/* Progress Bar */}
        <Box padding="20px" maxWidth="1150px" margin="auto">
          <ProgressBar step={2} totalSteps={4} />
        </Box>
        <Text fontSize="22px" fontWeight="bold" mt={4} textAlign={'center'}>
        What would be your first choice in what type of freelancing you would want to do?
        </Text>

        {/* Survey Question Component */}
        <SurveyQuestion
          selectedOption={formData.first_choice}
          setSelectedOption={(value) => setFormData({ ...formData, first_choice: value })}
        />


        <Box marginTop="150px">
        <NavigationButtons onNext={handleNext} onBack={handleBack} />
        </Box>
        {/* Navigation Buttons */}

        {/* Navbar at Bottom */}
        <Box marginTop="50px">
          <Navbar />
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyPage2;
